<template>
  <v-app>
    <toolbar></toolbar>

    <!-- ===== Imagen bienvenida (solo imagen + X) ===== -->
    <v-dialog
      v-model="showWelcomeDialog"
      max-width="500"
      content-class="ios-dialog-overlay"
    >
      <v-card flat class="welcome-card">
        <!-- Botón salir encima de la imagen -->
        <v-btn
          icon
          class="welcome-close-btn"
          @click="closeWelcomeDialog"
          aria-label="Cerrar"
        >
          X
        </v-btn>

        <v-img
          :src="welcomeImageSrc"
          contain
          height="auto"
          width="100%"
        ></v-img>
      </v-card>
    </v-dialog>
    <!-- ===== Fin Imagen bienvenida ===== -->

    <!-- FAB launcher estilo iOS (bot actual) -->
    <div class="launcher" @click="toggleChat">
      <v-avatar size="56" class="launcher-avatar">
        <img src="@/assets/bot.png" alt="Chat Ficenca">
      </v-avatar>
    </div>

    <!-- === NUEVO: FAB para re-abrir la imagen === -->
    <div
      class="promo-launcher"
      @click="openWelcomeDialog"
      aria-label="Abrir imagen de seguridad"
      title="Compra Segura"
    >
      <v-avatar size="56" class="glow-avatar">
        <img src="https://grupoficenca.com/img/cs.jpg" alt="Compra Segura Ficenca">
      </v-avatar>
    </div>
    <!-- === FIN NUEVO === -->

    <!-- Chat estilo iOS -->
    <v-dialog
      v-model="isChatOpen"
      persistent
      max-width="420px"
      transition="dialog-bottom-transition"
      content-class="ios-dialog-overlay"
    >
      <v-card class="ios-chat-card">
        <!-- Header tipo iOS -->
        <v-card-actions class="ios-chat-header">
          <v-spacer></v-spacer>
          <div class="ios-chat-title">Ficenca Chat</div>
          <v-spacer></v-spacer>
          <v-btn icon class="ios-close-btn" @click="toggleChat" aria-label="Cerrar">
            X
          </v-btn>
        </v-card-actions>

        <!-- Mensajes -->
        <v-card-text class="ios-chat-body">
          <div
            v-for="message in messages"
            :key="message.id"
            class="row-message"
          >
            <div
              :class="[
                'bubble',
                message.sender === 'bot' ? 'bot-bubble' : 'user-bubble'
              ]"
              v-html="message.text"
            ></div>
          </div>
        </v-card-text>

        <v-divider class="ios-divider"></v-divider>

        <!-- Acciones rápidas tipo pastilla -->
        <v-card-actions class="ios-quick-actions">
          <v-btn class="pill" rounded @click="selectOption('Ubicación')">
            Ver ubicación
          </v-btn>
          <v-btn class="pill" rounded @click="selectOption('Contacto')">
            Ver contacto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-main style="padding-bottom:50px;">
      <router-view />
    </v-main>

    <!-- Footer (sin cambios funcionales) -->
    <v-card flat color="#eeeeee">
      <v-card-actions style="padding:20px 20px">
        <img width="150" src="https://grupoficenca.com/img/logo.17c9b543.png" />
        <p style="font-weight:700;font-size:12px;padding:20px 0 0 20px">
          Ficenca Costa Rica©
        </p>
        <v-spacer></v-spacer>
        <img width="100" src="@/assets/logofiac.png" />
        <img width="100" src="@/assets/michelin.png" />
      </v-card-actions>
    </v-card>
    <div style="width:100%;background:#eeeeee;padding: 0 0 20px 20px">
      <v-btn icon text small href="mailto:info@grupoficenca.com" style="font-size:14px;">
        <i class="fas fa-envelope"></i>
      </v-btn>
      <v-btn icon text small href="https://goo.gl/maps/DddbeYdvZkqiDzXf8" target="_blank" style="font-size:14px;">
        <i class="fas fa-location-arrow"></i>
      </v-btn>
      <v-btn icon text target="_blank" small style="font-size:14px;" :href="`https://facebook.com/ficencacostarica`">
        <strong><i class="fab fa-facebook-f"></i></strong>
      </v-btn>
      <v-btn icon text target="_blank" small style="font-size:14px;" :href="`https://instagram.com/ficencacostarica`">
        <strong><i class="fab fa-instagram"></i></strong>
      </v-btn>
      <v-btn icon text target="_blank" small style="font-size:14px;" :href="`https://www.linkedin.com/company/ficencacr/`">
        <i class="fab fa-linkedin-in"></i>
      </v-btn>
      <v-btn icon text target="_blank" small style="font-size:14px;" :href="`https://api.whatsapp.com/send?phone=50670188845`">
        <strong><i class="fab fa-whatsapp"></i></strong>
      </v-btn>
    </div>

    <div class="ddff">
      <div style="cursor:pointer;font-size:8px;text-align:center;color:white" @click="irCreador()">
        Brings | Developer
      </div>
    </div>
  </v-app>
</template>

<script>
import toolbar from './components/toolbar.vue'

export default {
  name: 'App',
  components: { toolbar },
  data: () => ({
    isChatOpen: false,
    userMessage: '',
    messages: [
      { id: 1, sender: 'bot', text: '¡Hola! Bienvenido al chat de Ficenca. ¿En qué podemos ayudarte?' }
    ],

    // Imagen bienvenida
    showWelcomeDialog: false,
    welcomeImageSrc: 'https://grupoficenca.com/img/comprasegura.jpg',
    welcomeVisitKey: 'ficenca_welcome_visits',
    maxWelcomeViews: 5
  }),
  mounted() {
    try {
      const visits = parseInt(localStorage.getItem(this.welcomeVisitKey) || '0', 10) + 1
      localStorage.setItem(this.welcomeVisitKey, String(visits))
      if (visits <= this.maxWelcomeViews) {
        this.showWelcomeDialog = true
      }
    } catch (e) {
      this.showWelcomeDialog = true
      console.warn('localStorage no disponible:', e)
    }
  },
  methods: {
    irCreador(){
      window.open(
        "https://api.whatsapp.com/send?phone=19146883125&text=Hola,%20me%20interesa%20crear%20mi%20marca",
        "_blank"
      )
    },
    toggleChat() {
      this.isChatOpen = !this.isChatOpen
    },
    selectOption(option) {
      this.messages.push({ id: Date.now(), sender: 'user', text: option })
      this.replyToOption(option)
    },
    replyToOption(option) {
      let reply = ''
      if (option === 'Ubicación') {
        reply = 'Estamos ubicados en bodega # 2 Av. 55, Vuelta del Virilla, Uruca, San José'
      } else if (option === 'Contacto') {
        reply = `Puedes contactarnos por:<br>
        <strong>- Administrativo:</strong><br> (506) 2231-0010<br>(506) 2265-2888<br><br>
        <strong>- Departamento de Ventas:</strong><br> (506) 8995-6226<br>(506) 8731-5650<br><br>
        <strong>- Servicio Técnico:</strong><br> (506) 7174-7038<br> (506) 2231-0010`
      }
      setTimeout(() => {
        this.messages.push({ id: Date.now(), sender: 'bot', text: reply })
      }, 450) // respuesta ágil tipo app
    },

    // Cerrar bienvenida y fijar en 5 para que no aparezca más automáticamente
    closeWelcomeDialog() {
      this.showWelcomeDialog = false
      try {
        localStorage.setItem(this.welcomeVisitKey, String(this.maxWelcomeViews))
      } catch (e) {}
    },

    // === NUEVO: abrir la imagen manualmente desde el botón flotante ===
    openWelcomeDialog() {
      this.showWelcomeDialog = true
      // No tocamos localStorage aquí para no reactivar el auto-show
    }
  }
}
</script>

<style scoped>
/* Tipografía iOS */
:host, * {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
}

/* ===== Launcher iOS (bot) ===== */
.launcher {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 10000;
  cursor: pointer;
}
.launcher-avatar {
  box-shadow: 0 10px 24px rgba(0,0,0,0.22), 0 2px 6px rgba(0,0,0,0.12);
  background: #ffffff;
  transition: transform .15s ease, box-shadow .2s ease;
}
.launcher-avatar:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(0,0,0,0.24), 0 4px 10px rgba(0,0,0,0.12);
}

/* ===== NUEVO: Launcher para re-abrir imagen ===== */
.promo-launcher {
  position: fixed;
  right: 16px;
  bottom: 88px; /* encima del bot actual */
  z-index: 10000;
  cursor: pointer;
}
.glow-avatar {
  background: #ffffff;
  /* brillo pulsante: apaga/enciende */
  animation: pulseGlow 2.2s ease-in-out infinite;
  box-shadow:
    0 2px 6px rgba(0,0,0,0.12),
    0 0 0 0 rgba(10,132,255,0.0);
}
.glow-avatar:hover {
  transform: translateY(-2px);
}
@keyframes pulseGlow {
  0% {
    box-shadow:
      0 2px 6px rgba(0,0,0,0.12),
      0 0 0 0 rgba(10,132,255,0.00);
  }
  50% {
    box-shadow:
      0 10px 24px rgba(0,0,0,0.22),
      0 0 0 10px rgba(10,132,255,0.18); /* halo encendido */
  }
  100% {
    box-shadow:
      0 2px 6px rgba(0,0,0,0.12),
      0 0 0 0 rgba(10,132,255,0.00);
  }
}

/* ===== Dialog/Card estilo iOS (chat) ===== */
.ios-dialog-overlay {
  backdrop-filter: blur(2px);
}
.ios-chat-card {
  height: 520px;
  display: flex;
  flex-direction: column;
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(0,0,0,0.18);
}

/* Header tipo iMessage */
.ios-chat-header {
  position: relative;
  height: 48px;
  background: #f7f7f7;
  border-bottom: 1px solid #e5e5ea;
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.ios-chat-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  color: #111;
  letter-spacing: -0.2px;
}
.ios-close-btn {
  color: #111 !important;
}

/* Área de mensajes */
.ios-chat-body {
  flex: 1;
  background: #fff;
  padding: 12px 12px 0 12px;
  overflow-y: auto;
}

/* Fila de mensaje */
.row-message {
  display: flex;
  margin: 6px 0;
}

/* Burbujas estilo iMessage */
.bubble {
  max-width: 78%;
  padding: 10px 12px;
  border-radius: 18px;
  line-height: 1.45;
  word-break: break-word;
  font-size: 14.5px;
}
.bot-bubble {
  background: #f2f2f7;
  color: #111;
  border-top-left-radius: 6px;
  margin-right: auto;
  box-shadow: inset 0 0 0 1px rgba(0,0,0,0.04);
}
.user-bubble {
  background: #0a84ff;
  color: #fff;
  border-top-right-radius: 6px;
  margin-left: auto;
  box-shadow: 0 2px 6px rgba(10,132,255,0.35);
}

/* Separador sutil */
.ios-divider {
  opacity: 0.6;
}

/* Acciones rápidas en pastillas */
.ios-quick-actions {
  gap: 8px;
  padding: 10px 12px 14px;
  display: flex;
  justify-content: center;
}
.pill {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  font-size: 12.5px !important;
  padding: 8px 14px !important;
  border-radius: 999px !important;
  background: #e9f2ff !important;
  color: #0a84ff !important;
  box-shadow: none !important;
}
.pill:focus,
.pill:hover {
  background: #d9eaff !important;
}

/* ===== Estilos Imagen Bienvenida ===== */
.welcome-card {
  position: relative;
  border-radius: 0 !important;
  box-shadow: none !important;
  overflow: hidden;
}
.welcome-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  color: white !important;
  background: rgba(0,0,0,0.4) !important;
  z-index: 10;
}

/* Footer tuyo */
.ddff {
  background: #165198;
  padding: 10px 0;
}

/* Selección */
*::selection {
  background: #165198;
  color: #fff;
}
</style>
